import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { Container } from '@fiverr-private/layout_components';
import { TrendUpIcon } from '@fiverr-private/visuals';

import {
    mapStateToProps as mapChipStateToProps,
    mapDispatchToProps as mapChipDispatchToProps,
} from '../connectSuggestionItem';
import { aiPillChipClass, aiPillRowSelectedClass } from '../styles.ve.css';

const TrendingChip = ({ id, value, isSelected, onClick, icon }) => {
    const handleClick = (e) => {
        e.preventDefault();
        onClick(value);
    };

    return (
        <Container
            as="button"
            type="button"
            className={classNames(aiPillChipClass, { selected: isSelected, [aiPillRowSelectedClass]: isSelected })}
            display="inlineFlex"
            alignItems="center"
            gap="2"
            paddingX={{ default: '3', md: '4' }}
            paddingY={{ default: '1', md: '1.5' }}
            borderRadius="circle"
            color="grey_1200"
            fontSize={{ default: 'b_sm', md: 'b_md' }}
            onClick={handleClick}
            data-id={id}
        >
            {icon ? <img src={icon} alt="" width="16" height="16" /> : <TrendUpIcon size="sm" />}
            <span>{value}</span>
        </Container>
    );
};

TrendingChip.propTypes = {
    id: PropTypes.string.isRequired,
    value: PropTypes.string,
    isSelected: PropTypes.bool,
    onClick: PropTypes.func,
    icon: PropTypes.string,
};

TrendingChip.defaultProps = {
    value: '',
    isSelected: false,
    onClick: () => true,
    icon: '',
};

const ConnectedTrendingChip = connect(mapChipStateToProps, mapChipDispatchToProps)(TrendingChip);

export { TrendingChip };
export default ConnectedTrendingChip;
